export * from "-!../../../../../node_modules/cache-loader/dist/cjs.js!../../../../../node_modules/buble-loader/index.js??ref--2-1!../../../../../node_modules/vue-loader/lib/loaders/templateLoader.js??ref--2!../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./FacultySearch.vue?vue&type=template&id=5c449ce7"


//////////////////
// WEBPACK FOOTER
// ./scripts/vue/components/FacultySearch.vue?vue&type=template&id=5c449ce7
// module id = 403
// module chunks = 0